<script lang='ts'>
    const { children } = $props();
</script>

<div>
    {@render children()}
</div>

<style lang='scss'>
  @use '@otto-ec/design-tokens/tokens';

  div {
    font: tokens.$oc-semantic-font-copy-100;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
</style>
